import { Link, useStaticQuery, graphql  } from "gatsby"
import React, { useState } from "react"
import logo from '../../images/logo.png'

const Navbar = ({}) => {
  const { dataJson } = useStaticQuery(
    graphql`
      query {
        dataJson(content_type: {eq: "menu"}) {
          main_menu {
            title
            type
			externalLink
          }
        }
      }
    `
  )
const menu = dataJson.main_menu
const [menuIsOpen, setmenuIsOpen] = useState(false);

const menuToggleHandler = () => {
	const menuState = menuIsOpen
	menuState ? setmenuIsOpen(false) : setmenuIsOpen(true)
}

  return (
    <header>
      <nav className={['main-menu', menuIsOpen ? null : 'closed'].join(' ')} id="navbar">
				<div className="container-fluid">
					<div className="row between-xs middle-xs">
						<div className="col navbar-mobile flex between-xs align-center">
							<div className="brand">
								<Link to="/">
									<img src={logo} alt="Bedre Psykiatri logo" />
								</Link>
							</div>
							<button className="menu-toggle btn" aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation" onClick={menuToggleHandler}>
									<span className="icon-bar top-bar"></span>
									<span className="icon-bar middle-bar"></span>
									<span className="icon-bar bottom-bar"></span>
							</button>
						<div className="col main-menu-inner">
							<ul className="list-inline text-left">
								{menu.map((item, i) =>
								<li key={i}>
									{item.type === 'internal' ?

									<Link className="h5" to={item.externalLink}>{item.title}</Link>
									:
									<a className="h5" href={item.externalLink} target="_self" rel="noopener">{item.title}</a>
									}
								</li>
								)}
							</ul>
						</div>
					</div>
          </div>
				</div>
			</nav>
    </header>
  )
}

export default Navbar
